// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fts-18{font-size:18px}.fts-12{font-size:12px}.w-100p{width:100%}.zoom-d5{zoom:.5}", ""]);
// Exports
module.exports = exports;
